import React, { Component } from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import Title from "../general/title"
import colorArray from "../../helpers/colorArray"
import moment from "moment"
import ReactTable from "react-table"
import _ from "lodash"
import lineOptions from "helpers/lineOptions"
import { HorizontalBar } from "react-chartjs-2"
import times from "helpers/times"
import ImageExport from "components/ImageExport"
import FullTable from "components/FullTable"
import helpers from "helpers/helpers"

class SalesYTD extends Component {
	constructor(props) {
		super(props)
		this.state = {
			dayOfYear: moment().dayOfYear(),
			builderSales: [],
			builderSalesType: [],
			salesPrice: [],
			squareFootage: [],
			realtorSales: [],
			ethnicity: []
		}
	}

	builderSales = () => {
		// this method has to be way easier.  look at this later.
		let time = times()
		let property = this.props.activeProperties[0]
		let ret = {}
		let d = {}
		let totals = {}
		let year = new Date().getFullYear()
		let years = [(year - 1).toString(), year.toString()]
		let labels = []
		let activeBuilders = []
		let tableDataWithTypes = []
		let types = {} // object containing the breakout of year + builder + lot type
		_.forEach(this.props.payload.exec.sales, (v) => {
			if (v.transfer_date) {
				return
			}
			let y = moment.unix(v.sale_date).format("YYYY")
			// Ensure previous years end at this point in current years
			let doy = moment.unix(v.sale_date).dayOfYear()

			if (doy > this.state.dayOfYear) {
				return
			}
			if (y < time.year - 1) {
				return
			}
			if (v.property !== property) {
				return
			}
			let f = _.find(activeBuilders, { id: v.builder })
			let builder = _.find(this.props.payload.public.builders, { id: v.builder })
			if (!f && builder) {
				activeBuilders.push(builder)
			}
			if(!builder) return
			builder.name = builder.name.replace(/\./g, "")
			// Lot type breakout logic
			let type = _.find(this.props.payload.public.lot_types, { id: v.lot_type })
			if (!type) {
				return
			}
			let path = `${builder.name}.${type.name}.${y}`
			if (!_.has(types, path)) {
				_.setWith(types, path, 0, Object)
			}
			types[builder.name][type.name][y]++
		})
		_.forEach(this.props.payload.exec.busts, (v) => {
			if (v.transfer_date || v.property !== property) {
				return
			}
			let y = moment.unix(v.sale_date).format("YYYY")
			// Ensure previous years end at this point in current years
			let doy = moment.unix(v.sale_date).dayOfYear()
			if (doy > this.state.dayOfYear) {
				return
			}
			if (y < time.year - 1) {
				return
			}
			let f = _.find(activeBuilders, { id: v.builder })
			let builder = _.find(this.props.payload.public.builders, { id: v.builder })
			if (!f) {
				if (builder) {
					activeBuilders.push(builder)
				}
			}
			// Lot type breakout logic
			let type = _.find(this.props.payload.public.lot_types, { id: v.lot_type })
			if (!type) {
				return
			}
			let path = `${builder.name}.${type.name}.${y}`
			if (!_.has(types, path)) {
				_.setWith(types, path, -1, Object)
			}
			types[builder.name][type.name][y]--
		})
		_.forEach(activeBuilders, (v) => {
			labels.push(v.name.replace(/[^\w- ]+/g, ""))
		})
		// total them first
		_.forEach(this.props.payload.exec.sales, (v) => {
			if (v.cancel_date || v.transfer_date) {
				return
			}
			if (v.property !== property) {
				return
			}
			let y = moment.unix(v.sale_date).format("Y")
			if (!years.includes(y)) {
				return
			}
			let builder = _.find(activeBuilders, { id: v.builder })
			if (!builder) {
				return
			}
			// Ensure previous years end at this point in current years
			let doy = moment.unix(v.sale_date).dayOfYear()
			if (doy > this.state.dayOfYear) {
				return
			}

			let name = builder.name.replace(/[^\w- ]+/g, "")
			if (!_.has(ret, `${y}.${name}`)) {
				_.set(ret, `${y}.${name}`, 0)
			}
			ret[y][name]++
		})
		_.forEach(this.props.payload.exec.busts, (v) => {
			if (v.cancel_date || v.transfer_date) {
				return
			}
			if (v.property !== property) {
				return
			}
			let y = moment.unix(v.bustout_date).format("Y")
			if (!years.includes(y)) {
				return
			}
			let builder = _.find(activeBuilders, { id: v.builder })
			if (!builder) {
				return
			}
			// Ensure previous years end at this point in current years
			let doy = moment.unix(v.bustout_date).dayOfYear()
			if (doy > this.state.dayOfYear) {
				return
			}

			let name = builder.name.replace(/[^\w- ]+/g, "")
			if (!_.has(ret, `${y}.${name}`)) {
				_.set(ret, `${y}.${name}`, 0)
			}
			ret[y][name]--
		})
		// set 0's for no data
		_.forEach(ret, (ages, y) => {
			_.forEach(labels, (v) => {
				if (!_.has(ret[y], v)) {
					_.set(ret[y], v, 0)
				}
			})
		})
		// remove undefined from teh deletion above, reset array keys
		activeBuilders = activeBuilders.filter((r) => {
			if (r) {
				return r
			}
		})
		// totals for each year to base percentages off of
		_.forEach(years, (y) => {
			let i = 0
			_.forEach(ret[y], (value) => {
				i += value
			})
			totals[y] = i
		})
		// now create arrays of every year combo
		_.forEach(ret, (v, k) => {
			if (!years.includes(k)) {
				return
			}
			_.forEach(v, (value, label) => {
				label = label.replace(/[^\w- ]+/g, "")
				if (!_.has(d, `${label}`)) {
					_.set(d, `${label}`, [])
				}
				if (!d[label]) {
					//console.log(label)
				}
				d[label].push(value)
			})
		})
		// create table data
		let tableData = []
		_.forEach(d, (v, k) => {
			let r = {
				builder: k,
			}
			r[years[0]] = parseFloat(((v[0] / totals[years[0]]) * 100).toFixed(2))
			r[years[1]] = parseFloat(((v[1] / totals[years[1]]) * 100).toFixed(2))
			//console.log(r)
			// Percent
			if (r[years[0]] == 0 || r[years[1]] == 0) {
				r["changed"] = 0
			} else if (r[years[0]] > r[years[1]]) {
				let t = r[years[1]] / r[years[0]]
				t = t * 100
				t = (100 - t).toFixed(2)
				t = t * -1
				if (isNaN(t)) {
					t = 0
				}
				r["changed"] = t
			} else {
				let t = r[years[1]] / r[years[0]]
				t = t - 1
				t = t * 100
				t = t.toFixed(2)
				if (isNaN(t)) {
					t = 0
				}
				r["changed"] = t
			}
			//r["changed"] = Math.round(p * 100)
			tableData.push(r)
		})

		// Now for lot type table data
		_.forEach(types, (level1, builderName) => {
			_.forEach(level1, (level2, lotType) => {
				let r = {
					builder: builderName,
					lot_type: lotType,
				}
				_.forEach(level2, (v, y) => {
					r[y] = v && totals[y] ? parseFloat(((v / totals[y]) * 100).toFixed(2)) : 0
				})
				if (!r[years[0]]) {
					r[years[0]] = 0
				}
				if (!r[years[1]]) {
					r[years[1]] = 0
				}
				if (r[years[0]] == 0 || r[years[1]] == 0) {
					r["changed"] = 0
				} else if (r[years[0]] > r[years[1]]) {
					let t = r[years[1]] / r[years[0]]
					t = t * 100
					t = (100 - t).toFixed(2)
					t = t * -1
					if (isNaN(t)) {
						t = 0
					}
					r["changed"] = t
				} else {
					let t = r[years[1]] / r[years[0]]
					t = t - 1
					t = t * 100
					t = t.toFixed(2)
					if (isNaN(t)) {
						t = 0
					}
					r["changed"] = t
				}
				tableDataWithTypes.push(r)
			})
		})
		let datasets = []
		let i = 0
		_.forEach(activeBuilders, (v) => {
			let obj = {
				label: activeBuilders[i].name,
				backgroundColor: colorArray[i],
				borderColor: colorArray[i],
				borderWidth: 1,
				hoverBackgroundColor: "rgba(50,149,236,0.5)",
				hoverBorderColor: "rgba(50,149,236,0.9)",
				data: d[activeBuilders[i].name],
			}
			datasets.push(obj)
			i++
		})
		// Reverse years and data so latest is on top.
		years = _.reverse(years)
		_.forEach(datasets, (v, k) => {
			v.data = _.reverse(v.data)
		})
		const data = {
			labels: years,
			datasets: datasets,
		}
		const columns = [
			{
				Header: "Builder",
				accessor: "builder",
				filterMethod: (f, r) => helpers.tableText(f, r, "builder"),
			},
			{
				Header: `Total ` + years[0] + ` Sales`,
				accessor: years[0],
				Cell: (props) => props.value + "%",
			},
			{
				Header: `Total ` + years[1] + ` Sales`,
				accessor: years[1],
				Cell: (props) => props.value + "%",
			},
			{
				Header: "% Change",
				accessor: "changed",
				Cell: (props, pdf) => {
					if (pdf === true) {
						return props.value
					}
					if (props.value > 0) {
						return (
							<span style={{ color: "green" }}>
								<i className="fas fa-caret-up" />
								{props.value}%
							</span>
						)
					} else {
						return (
							<span style={{ color: "red" }}>
								<i className="fas fa-caret-down" />
								{props.value}%
							</span>
						)
					}
				},
			},
		]
		const typeColumns = [
			{
				Header: "Builder",
				accessor: "builder",
				filterMethod: (f, r) => helpers.tableText(f, r, "builder"),
			},
			{
				Header: "Lot Type",
				accessor: "lot_type",
				filterMethod: (f, r) => helpers.tableText(f, r, "lot_type"),
			},
			{
				Header: `Total ` + years[0] + ` Sales`,
				accessor: years[0],
				Cell: (props) => props.value + "%" || "0.00%",
			},
			{
				Header: `Total ` + years[1] + ` Sales`,
				accessor: years[1],
				Cell: (props) => props.value + "%" || "0.00%",
			},
			{
				Header: "% Change",
				accessor: "changed",
				Cell: (props) => {
					if (props.value > 0) {
						return (
							<span style={{ color: "green" }}>
								<i className="fas fa-caret-up" />
								{props.value}%
							</span>
						)
					} else {
						return (
							<span style={{ color: "red" }}>
								<i className="fas fa-caret-down" />
								{props.value}%
							</span>
						)
					}
				},
			},
		]
		return (
			<div className="content">
				<div className="statBox__row">
					<div className="statBox__box">
						<ImageExport name="BuilderSales" />
						<HorizontalBar data={data} options={lineOptions} />
					</div>
				</div>
				<div className="statBox__row">
					<div className="statBox__box">
						<FullTable
							data={tableData}
							columns={columns}
							name="salesYTD__builderSales"
							title="Builder Sales"
						/>
					</div>
				</div>
				<div className="statBox__row">
					<div className="statBox__box">
						<h3>By Lot Type</h3>
						<FullTable
							data={tableDataWithTypes}
							columns={typeColumns}
							name="BuilderSalesLotType"
							title="BuilderSalesLotType"
						/>
					</div>
				</div>
			</div>
		)
	}

	salesPrice = () => {
		let ret = {}
		let time = times()
		let d = {}
		let totals = {}
		let year = new Date().getFullYear()
		let years = [(year - 1).toString(), year.toString()]
		let labels = [
			"$251 - $300K",
			"$301 - $350K",
			"$351 - $400K",
			"$401 - $450K",
			"$451 - $500K",
			"$501 - $550K",
			"$551 - $600K",
			"$600K +",
		]
		// total them first
		_.forEach(this.props.payload.exec.sales, (v) => {
			if (v.transfer_date) {
				return
			}
			if (!v.price) {
				return
			}
			let y = moment.unix(v.sale_date).format("Y")
			if (y < time.year - 1) {
				return
			}
			// Ensure previous years end at this point in current years
			let doy = moment.unix(v.sale_date).dayOfYear()
			if (doy > this.state.dayOfYear) {
				return
			}
			let bin
			if (v.price > 250000 && v.price <= 300000) {
				bin = labels[0]
			} else if (v.price > 300000 && v.price <= 350000) {
				bin = labels[1]
			} else if (v.price > 350000 && v.price <= 400000) {
				bin = labels[2]
			} else if (v.price > 400000 && v.price <= 450000) {
				bin = labels[3]
			} else if (v.price > 450000 && v.price <= 500000) {
				bin = labels[4]
			} else if (v.price > 500000 && v.price <= 550000) {
				bin = labels[5]
			} else if (v.price > 550000 && v.price < 600000) {
				bin = labels[6]
			} else if (v.price > 600000) {
				bin = labels[7]
			} else {
				return
			}

			if (!_.has(ret, `${y}.${bin}`)) {
				_.set(ret, `${y}.${bin}`, 0)
			}
			ret[y][bin]++
		})
		_.forEach(this.props.payload.exec.busts, (v) => {
			if (!v.price) {
				return
			}
			let y = moment.unix(v.bustout_date).format("Y")
			if (year < time.year - 1) {
				return
			}
			// Ensure previous years end at this point in current years
			let doy = moment.unix(v.bustout_date).dayOfYear()
			if (doy > this.state.dayOfYear) {
				return
			}
			let bin
			if (v.price > 250000 && v.price <= 300000) {
				bin = labels[0]
			} else if (v.price > 300000 && v.price <= 350000) {
				bin = labels[1]
			} else if (v.price > 350000 && v.price <= 400000) {
				bin = labels[2]
			} else if (v.price > 400000 && v.price <= 450000) {
				bin = labels[3]
			} else if (v.price > 450000 && v.price <= 500000) {
				bin = labels[4]
			} else if (v.price > 500000 && v.price <= 550000) {
				bin = labels[5]
			} else if (v.price > 550000 && v.price < 600000) {
				bin = labels[6]
			} else if (v.price > 600000) {
				bin = labels[7]
			} else {
				return
			}

			if (!_.has(ret, `${y}.${bin}`)) {
				_.set(ret, `${y}.${bin}`, 0)
			}
			ret[y][bin]--
		})
		//console.log(ret)
		// set 0's for no data
		_.forEach(ret, (ages, y) => {
			_.forEach(labels, (v) => {
				if (!_.has(ret[y], v)) {
					_.set(ret[y], v, 0)
				}
			})
		})
		// totals for each year to base percentages off of
		_.forEach(years, (y) => {
			let i = 0
			_.forEach(ret[y], (value) => {
				i += value
			})
			totals[y] = i
		})
		// now create arrays of every year combo
		_.forEach(ret, (v, k) => {
			if (!years.includes(k)) {
				return
			}
			_.forEach(v, (value, label) => {
				if (!_.has(d, `${label}`)) {
					_.set(d, `${label}`, [])
				}
				if (value < 5) {
					//value = randomNum(5, 8)
				}
				d[label].push(value)
			})
		})
		// create table data
		let tableData = []
		_.forEach(d, (v, k) => {
			let r = {
				price: k,
			}
			r[years[0]] = ((v[0] / totals[years[0]]) * 100).toFixed(2)
			r[years[1]] = ((v[1] / totals[years[1]]) * 100).toFixed(2)
			// Percent
			let p = r[years[1]] / r[years[0]]
			if (r[years[0]] > r[years[1]]) {
				let t = r[years[1]] / r[years[0]]
				t = t * 100
				t = (100 - t).toFixed(2)
				t = t * -1
				if (isNaN(t)) {
					t = 0
				}
				r["changed"] = t
			} else {
				let t = r[years[1]] / r[years[0]]
				t = t - 1
				t = t * 100
				t = t.toFixed(2)
				if (isNaN(t)) {
					t = 0
				}
				r["changed"] = t
			}
			//r["changed"] = Math.round(p * 100)
			tableData.push(r)
		})
		// Reverse years and data so latest is on top.
		years = _.reverse(years)
		_.forEach(d, (v, k) => {
			v = _.reverse(v)
		})
		const data = {
			labels: years,
			datasets: [
				{
					label: "$251 - $300K",
					backgroundColor: colorArray[1],
					borderColor: colorArray[1],
					borderWidth: 1,
					hoverBackgroundColor: "rgba(50,149,236,0.5)",
					hoverBorderColor: "rgba(50,149,236,0.9)",
					data: d["$251 - $300K"],
				},
				{
					label: "$301 - $350K",
					backgroundColor: colorArray[8],
					borderColor: colorArray[8],
					borderWidth: 1,
					hoverBackgroundColor: "rgba(50,149,236,0.5)",
					hoverBorderColor: "rgba(50,149,236,0.9)",
					data: d["$301 - $350K"],
				},
				{
					label: "$351 - $400K",
					backgroundColor: colorArray[3],
					borderColor: colorArray[3],
					borderWidth: 1,
					hoverBackgroundColor: "rgba(50,149,236,0.5)",
					hoverBorderColor: "rgba(50,149,236,0.9)",
					data: d["$351 - $400K"],
				},
				{
					label: "$401 - $450K",
					backgroundColor: colorArray[4],
					borderColor: colorArray[4],
					borderWidth: 1,
					hoverBackgroundColor: "rgba(50,149,236,0.5)",
					hoverBorderColor: "rgba(50,149,236,0.9)",
					data: d["$401 - $450K"],
				},
				{
					label: "$451 - $500K",
					backgroundColor: colorArray[5],
					borderColor: colorArray[5],
					borderWidth: 1,
					hoverBackgroundColor: "rgba(50,149,236,0.5)",
					hoverBorderColor: "rgba(50,149,236,0.9)",
					data: d["$451 - $500K"],
				},
				{
					label: "$501 - $550K",
					backgroundColor: colorArray[6],
					borderColor: colorArray[6],
					borderWidth: 1,
					hoverBackgroundColor: "rgba(50,149,236,0.5)",
					hoverBorderColor: "rgba(50,149,236,0.9)",
					data: d["$501 - $550K"],
				},
				{
					label: "$551 - $600K",
					backgroundColor: colorArray[10],
					borderColor: colorArray[10],
					borderWidth: 1,
					hoverBackgroundColor: "rgba(50,149,236,0.5)",
					hoverBorderColor: "rgba(50,149,236,0.9)",
					data: d["$551 - $600K"],
				},
				{
					label: "$600K +",
					backgroundColor: colorArray[8],
					borderColor: colorArray[8],
					borderWidth: 1,
					hoverBackgroundColor: "rgba(50,149,236,0.5)",
					hoverBorderColor: "rgba(50,149,236,0.9)",
					data: d["$600K +"],
				},
			],
		}

		const columns = [
			{
				Header: "Sales Price",
				accessor: "price",
			},
			{
				Header: years[0],
				accessor: years[0],
				Cell: (props) => props.value + "%",
			},
			{
				Header: years[1],
				accessor: years[1],
				Cell: (props) => props.value + "%",
			},
			{
				Header: "% Change",
				accessor: "changed",
				Cell: (props, pdf) => {
					if (pdf === true) {
						return props.value
					}
					if (props.value > 0) {
						return (
							<span style={{ color: "green" }}>
								<i className="fas fa-caret-up" />
								{props.value}%
							</span>
						)
					} else {
						return (
							<span style={{ color: "red" }}>
								<i className="fas fa-caret-down" />
								{props.value}%
							</span>
						)
					}
				},
			},
		]

		return (
			<div className="content">
				<div className="statBox__row">
					<div className="statBox__box">
						<ImageExport name="SalesPrice" />
						<HorizontalBar data={data} options={lineOptions} />
					</div>
				</div>
				<div className="statBox__row">
					<div className="statBox__box">
						<FullTable data={tableData} columns={columns} name="salesYTD__salesprice" title="SalesPrice" />
					</div>
				</div>
			</div>
		)
	}
	
	squareFootage = () => {
		let property = this.props.activeProperties[0]
		let ret = {}
		let time = times()
		let d = {}
		let totals = {}
		let year = new Date().getFullYear()
		let years = [(year - 1).toString(), year.toString()]
		let labels = [
			"< 2000",
			"2000 - 2500",
			"2501 - 3000",
			"3001 - 3500",
			"3501 - 4000",
			"4001 - 4500",
			"4501 - 5000",
			"5001+",
		]
		// total them first
		_.forEach(this.props.payload.exec.sales, (v) => {
			if (v.transfer_date) {
				return
			}
			if (year < time.year - 1 || !v.sqft) {
				return
			}
			// Ensure previous years end at this point in current years
			let doy = moment.unix(v.sale_date).dayOfYear()
			if (doy > this.state.dayOfYear) {
				return
			}
			let y = moment.unix(v.sale_date).format("Y")
			let bin
			if (v.sqft > 2000 && v.sqft <= 2500) {
				bin = labels[1]
			} else if (v.sqft > 2500 && v.sqft <= 3000) {
				bin = labels[2]
			} else if (v.sqft > 3000 && v.sqft <= 3500) {
				bin = labels[3]
			} else if (v.sqft > 3500 && v.sqft <= 4000) {
				bin = labels[4]
			} else if (v.sqft > 4000 && v.sqft <= 4500) {
				bin = labels[5]
			} else if (v.sqft > 4500 && v.sqft <= 5000) {
				bin = labels[6]
			} else if (v.sqft > 5000) {
				bin = labels[7]
			} else {
				bin = labels[0]
			}

			if (!_.has(ret, `${y}.${bin}`)) {
				_.set(ret, `${y}.${bin}`, 0)
			}
			ret[y][bin]++
		})
		_.forEach(this.props.payload.exec.busts, (v) => {
			if (year < time.year - 1 || !v.sqft) {
				return
			}
			// Ensure previous years end at this point in current years
			let doy = moment.unix(v.bustout_date).dayOfYear()
			if (doy > this.state.dayOfYear) {
				return
			}
			let y = moment.unix(v.bustout_date).format("Y")
			let bin
			if (v.sqft > 2000 && v.sqft <= 2500) {
				bin = labels[1]
			} else if (v.sqft > 2500 && v.sqft <= 3000) {
				bin = labels[2]
			} else if (v.sqft > 3000 && v.sqft <= 3500) {
				bin = labels[3]
			} else if (v.sqft > 3500 && v.sqft <= 4000) {
				bin = labels[4]
			} else if (v.sqft > 4000 && v.sqft <= 4500) {
				bin = labels[5]
			} else if (v.sqft > 4500 && v.sqft <= 5000) {
				bin = labels[6]
			} else if (v.sqft > 5000) {
				bin = labels[7]
			} else {
				bin = labels[0]
			}

			if (!_.has(ret, `${y}.${bin}`)) {
				_.set(ret, `${y}.${bin}`, 0)
			}
			ret[y][bin]--
		})
		//console.log(ret)
		// set 0's for no data
		_.forEach(ret, (ages, year) => {
			_.forEach(labels, (v) => {
				if (!_.has(ret[year], v)) {
					_.set(ret[year], v, 0)
				}
			})
		})
		//console.log(ret)
		// totals for each year to base percentages off of
		_.forEach(years, (year) => {
			let i = 0
			_.forEach(ret[year], (value) => {
				i += value
			})
			totals[year] = i
		})
		///console.log(totals)
		// now create arrays of every year combo
		_.forEach(ret, (v, k) => {
			if (!years.includes(k)) {
				return
			}
			_.forEach(v, (value, label) => {
				if (!_.has(d, `${label}`)) {
					_.set(d, `${label}`, [])
				}
				if (value < 5) {
					//value = randomNum(5, 8)
				}
				d[label].push(value)
			})
		})
		//console.log(d)
		// create table data
		let tableData = []
		_.forEach(d, (v, k) => {
			let r = {
				sqft: k,
			}
			r[years[0]] = ((v[0] / totals[years[0]]) * 100).toFixed(2)
			r[years[1]] = ((v[1] / totals[years[1]]) * 100).toFixed(2)
			//console.log(r)
			// Percent
			let p = r[years[1]] / r[years[0]]
			//console.log(r[years[0]], r[years[1]])
			if (r[years[0]] > r[years[1]]) {
				let t = r[years[1]] / r[years[0]]
				t = t * 100
				t = (100 - t).toFixed(2)
				t = t * -1
				if (isNaN(t)) {
					t = 0
				}
				r["changed"] = t
			} else {
				let t = r[years[1]] / r[years[0]]
				t = t - 1
				t = t * 100
				t = t.toFixed(2)
				if (isNaN(t)) {
					t = 0
				}
				r["changed"] = t
			}
			//r["changed"] = Math.round(p * 100)
			tableData.push(r)
		})
		// Reverse years and data so latest is on top.
		years = _.reverse(years)
		_.forEach(d, (v, k) => {
			v = _.reverse(v)
		})
		const data = {
			labels: years,
			datasets: [
				{
					label: "< 2000",
					backgroundColor: colorArray[11],
					borderColor: colorArray[11],
					borderWidth: 1,
					hoverBackgroundColor: "rgba(50,149,236,0.5)",
					hoverBorderColor: "rgba(50,149,236,0.9)",
					data: d["< 2000"],
				},
				{
					label: "2000 - 2500",
					backgroundColor: colorArray[1],
					borderColor: colorArray[1],
					borderWidth: 1,
					hoverBackgroundColor: "rgba(50,149,236,0.5)",
					hoverBorderColor: "rgba(50,149,236,0.9)",
					data: d["2000 - 2500"],
				},
				{
					label: "2501 - 3000",
					backgroundColor: colorArray[8],
					borderColor: colorArray[8],
					borderWidth: 1,
					hoverBackgroundColor: "rgba(50,149,236,0.5)",
					hoverBorderColor: "rgba(50,149,236,0.9)",
					data: d["2501 - 3000"],
				},
				{
					label: "3001 - 3500",
					backgroundColor: colorArray[3],
					borderColor: colorArray[3],
					borderWidth: 1,
					hoverBackgroundColor: "rgba(50,149,236,0.5)",
					hoverBorderColor: "rgba(50,149,236,0.9)",
					data: d["3001 - 3500"],
				},
				{
					label: "3501 - 4000",
					backgroundColor: colorArray[4],
					borderColor: colorArray[4],
					borderWidth: 1,
					hoverBackgroundColor: "rgba(50,149,236,0.5)",
					hoverBorderColor: "rgba(50,149,236,0.9)",
					data: d["3501 - 4000"],
				},
				{
					label: "4001 - 4500",
					backgroundColor: colorArray[5],
					borderColor: colorArray[5],
					borderWidth: 1,
					hoverBackgroundColor: "rgba(50,149,236,0.5)",
					hoverBorderColor: "rgba(50,149,236,0.9)",
					data: d["4001 - 4500"],
				},
				{
					label: "4501 - 5000",
					backgroundColor: colorArray[6],
					borderColor: colorArray[6],
					borderWidth: 1,
					hoverBackgroundColor: "rgba(50,149,236,0.5)",
					hoverBorderColor: "rgba(50,149,236,0.9)",
					data: d["4501 - 5000"],
				},
				{
					label: "5001+",
					backgroundColor: colorArray[10],
					borderColor: colorArray[10],
					borderWidth: 1,
					hoverBackgroundColor: "rgba(50,149,236,0.5)",
					hoverBorderColor: "rgba(50,149,236,0.9)",
					data: d["5001+"],
				},
			],
		}

		const opts = {
			legend: {
				display: true,
				position: "bottom",
			},
			plugins: {
				datalabels: {
					clamp: true,
					formatter: (v, ctx) => ctx.dataset.label,
				},
			},
			scales: {
				xAxes: [
					{
						ticks: {
							beginAtZero: true,
						},
					},
				],
			},
		}

		const columns = [
			{
				Header: "Square Footage",
				accessor: "sqft",
			},
			{
				Header: years[0],
				accessor: years[0],
				Cell: (props) => props.value + "%",
			},
			{
				Header: years[1],
				accessor: years[1],
				Cell: (props) => props.value + "%",
			},
			{
				Header: "% Change",
				accessor: "changed",
				Cell: (props, pdf) => {
					if (pdf === true) {
						return props.value
					}
					if (props.value > 0) {
						return (
							<span style={{ color: "green" }}>
								<i className="fas fa-caret-up" />
								{props.value}%
							</span>
						)
					} else {
						return (
							<span style={{ color: "red" }}>
								<i className="fas fa-caret-down" />
								{props.value}%
							</span>
						)
					}
				},
			},
		]

		return (
			<div className="content">
				<div className="statBox__row">
					<div className="statBox__box">
						<ImageExport name="SquareFootage" />
						<HorizontalBar data={data} options={lineOptions} />
					</div>
				</div>
				<div className="statBox__row">
					<div className="statBox__box">
						<FullTable
							data={tableData}
							columns={columns}
							name="salesYTD__sqft"
							title="SquareFootage"
						/>
					</div>
				</div>
			</div>
		)
	}

	ethnicity = () => {
		let ret = {}
		let d = {}
		let totals = {}
		let year = new Date().getFullYear()
		let years = [year.toString(), (year - 1).toString()]
		let labels = this.props.payload.public.options.ethnicity
		// total them first
		_.forEach(this.props.payload.exec.sales, (v) => {
			if (v.cancel_date || v.bustout_date || v.transfer_date) {
				return
			}
			if (!v.ethnicity) {
				return
			}
			let y = moment.unix(v.sale_date).format("Y")
			if (!_.has(ret, `${y}.${v.ethnicity}`)) {
				_.set(ret, `${y}.${v.ethnicity}`, 0)
			}
			ret[y][v.ethnicity]++
		})
		// set 0's for no data
		_.forEach(ret, (ages, y) => {
			_.forEach(labels, (v) => {
				if (!_.has(ret[y], v)) {
					_.set(ret[y], v, 0)
				}
			})
		})
		//console.log(ret)
		// totals for each year to base percentages off of
		_.forEach(years, (y) => {
			let i = 0
			_.forEach(ret[y], (value) => {
				i += value
			})
			totals[y] = i
		})
		//console.log(totals)
		// now create arrays of every year combo
		_.forEach(ret, (v, k) => {
			if (!years.includes(k)) {
				return
			}
			_.forEach(v, (value, label) => {
				if (!_.has(d, `${label}`)) {
					_.set(d, `${label}`, [])
				}
				d[label].push(value)
			})
		})
		//console.log(d)
		// create table data
		let tableData = []
		_.forEach(d, (v, k) => {
			let r = {
				ethnicity: k,
			}
			r[years[0]] = ((v[0] / totals[years[0]]) * 100).toFixed(2)
			r[years[1]] = ((v[1] / totals[years[1]]) * 100).toFixed(2)
			//console.log(r)
			// Percent
			let p = r[years[1]] / r[years[0]]
			//console.log(r[years[0]], r[years[1]])
			if (r[years[0]] > r[years[1]]) {
				let t = r[years[1]] / r[years[0]]
				t = t * 100
				t = (100 - t).toFixed(2)
				t = t * -1
				if (isNaN(t)) {
					t = 0
				}
				r["changed"] = t
			} else {
				let t = r[years[1]] / r[years[0]]
				t = t - 1
				t = t * 100
				t = t.toFixed(2)
				if (isNaN(t)) {
					t = 0
				}
				r["changed"] = t
			}
			//r["changed"] = Math.round(p * 100)
			tableData.push(r)
		})

		let datasets = []
		let i = 0
		_.forEach(this.props.payload.public.options.ethnicity, (v) => {
			let obj = {
				label: this.props.payload.public.options.ethnicity[i],
				backgroundColor: colorArray[i],
				borderColor: colorArray[i],
				borderWidth: 1,
				hoverBackgroundColor: "rgba(50,149,236,0.5)",
				hoverBorderColor: "rgba(50,149,236,0.9)",
				data: d[this.props.payload.public.options.ethnicity[i]],
			}
			datasets.push(obj)
			i++
		})

		const data = {
			labels: years,
			datasets: datasets,
		}
		//console.log(data)

		const opts = {
			legend: {
				display: true,
				position: "bottom",
			},
			plugins: {
				datalabels: {
					clamp: true,
					formatter: (v, ctx) => ctx.dataset.label,
				},
			},
			scales: {
				xAxes: [
					{
						ticks: {
							beginAtZero: true,
						},
					},
				],
			},
		}

		const columns = [
			{
				Header: "Ethnicity",
				accessor: "ethnicity",
			},
			{
				Header: years[0],
				accessor: years[0],
				Cell: (props) => props.value + "%",
			},
			{
				Header: years[1],
				accessor: years[1],
				Cell: (props) => props.value + "%",
			},
			{
				Header: "% Change",
				accessor: "changed",
				Cell: (props, pdf) => {
					if (pdf === true) {
						return props.value
					}
					if (props.value > 0) {
						return (
							<span style={{ color: "green" }}>
								<i className="fas fa-caret-up" />
								{props.value}%
							</span>
						)
					} else {
						return (
							<span style={{ color: "red" }}>
								<i className="fas fa-caret-down" />
								{props.value}%
							</span>
						)
					}
				},
			},
		]

		return (
			<div className="statBox__row statBox__row--double">
				<div className="statBox__box">
					<ImageExport name="Ethnicity" />
					<h3 className="statBox__title">Ethnicity</h3>
					<HorizontalBar data={data} options={lineOptions} />
				</div>
				<div className="statBox__box">
					<FullTable data={tableData} columns={columns} name="salesYTD__ethnicity" title="Ethnicity" />
				</div>
			</div>
		)
	}

	occupation = () => {
		let ret = {}
		let d = {}
		let totals = {}
		let year = new Date().getFullYear()
		let years = [year.toString(), (year - 1).toString()]
		let labels = this.props.payload.public.options.occupations
		// total them first
		_.forEach(this.props.payload.exec.sales, (v) => {
			if (v.cancel_date || v.bustout_date || v.transfer_date) {
				return
			}
			if (!v.occupation) {
				return
			}
			let y = moment.unix(v.sale_date).format("Y")
			if (!_.has(ret, `${y}.${v.occupation}`)) {
				_.set(ret, `${y}.${v.occupation}`, 0)
			}
			ret[y][v.occupation]++
		})
		// set 0's for no data
		_.forEach(ret, (ages, y) => {
			_.forEach(labels, (v) => {
				if (!_.has(ret[y], v)) {
					_.set(ret[y], v, 0)
				}
			})
		})
		//console.log(ret)
		// totals for each year to base percentages off of
		_.forEach(years, (y) => {
			let i = 0
			_.forEach(ret[y], (value) => {
				i += value
			})
			totals[y] = i
		})
		//console.log(totals)
		// now create arrays of every year combo
		_.forEach(ret, (v, k) => {
			if (!years.includes(k)) {
				return
			}
			_.forEach(v, (value, label) => {
				if (!_.has(d, `${label}`)) {
					_.set(d, `${label}`, [])
				}
				d[label].push(value)
			})
		})
		//console.log(d)
		// create table data
		let tableData = []
		_.forEach(d, (v, k) => {
			let r = {
				occupation: k,
			}
			r[years[0]] = ((v[0] / totals[years[0]]) * 100).toFixed(2)
			r[years[1]] = ((v[1] / totals[years[1]]) * 100).toFixed(2)
			//console.log(r)
			// Percent
			let p = r[years[1]] / r[years[0]]
			//console.log(r[years[0]], r[years[1]])
			if (r[years[0]] > r[years[1]]) {
				let t = r[years[1]] / r[years[0]]
				t = t * 100
				t = (100 - t).toFixed(2)
				t = t * -1
				if (isNaN(t)) {
					t = 0
				}
				r["changed"] = t
			} else {
				let t = r[years[1]] / r[years[0]]
				t = t - 1
				t = t * 100
				t = t.toFixed(2)
				if (isNaN(t)) {
					t = 0
				}
				r["changed"] = t
			}
			//r["changed"] = Math.round(p * 100)
			tableData.push(r)
		})

		const columns = [
			{
				Header: "Occupation",
				accessor: "occupation",
				filterMethod: (f, r) => helpers.tableText(f, r, "occupation"),
			},
			{
				Header: years[0],
				accessor: years[0],
				Cell: (props) => props.value + "%",
			},
			{
				Header: years[1],
				accessor: years[1],
				Cell: (props) => props.value + "%",
			},
			{
				Header: "% Change",
				accessor: "changed",
				Cell: (props, pdf) => {
					if (pdf === true) {
						return props.value
					}
					if (props.value > 0) {
						return (
							<span style={{ color: "green" }}>
								<i className="fas fa-caret-up" />
								{props.value}%
							</span>
						)
					} else {
						return (
							<span style={{ color: "red" }}>
								<i className="fas fa-caret-down" />
								{props.value}%
							</span>
						)
					}
				},
			},
		]

		return (
			<div className="statBox__row">
				<div className="statBox__box">
					<h3 className="statBox__title">Occupation</h3>
					<FullTable data={tableData} columns={columns} name="salesYTD__occupations" title="Occupations" />
				</div>
			</div>
		)
	}

	realtorSales = () => {
		let ret = {}
		let d = {}
		let totals = {}
		let year = new Date().getFullYear()
		let years = [(year - 1).toString(), year.toString()]
		let labels = ["No", "Yes"]
		// total them first
		_.forEach(this.props.payload.exec.sales, (v) => {
			if (v.transfer_date) {
				return
			}
			// Ensure previous years end at this point in current years
			let doy = moment.unix(v.sale_date).dayOfYear()
			if (doy > this.state.dayOfYear) {
				return
			}
			let l = v.realtor_involved == 0 ? "No" : "Yes"
			let y = moment.unix(v.sale_date).format("Y")
			if (!_.has(ret, `${y}.${l}`)) {
				_.set(ret, `${y}.${l}`, 0)
			}
			ret[y][l]++
		})
		_.forEach(this.props.payload.exec.busts, (v) => {
			// Ensure previous years end at this point in current years
			let doy = moment.unix(v.bustout_date).dayOfYear()
			if (doy > this.state.dayOfYear) {
				return
			}
			let l = v.realtor_involved == 0 ? "No" : "Yes"
			let y = moment.unix(v.bustout_date).format("Y")
			if (!_.has(ret, `${y}.${l}`)) {
				_.set(ret, `${y}.${l}`, 0)
			}
			ret[y][l]--
		})
		//console.log(ret)
		// set 0's for no data
		_.forEach(ret, (ages, y) => {
			_.forEach(labels, (v) => {
				if (!_.has(ret[y], v)) {
					_.set(ret[y], v, 0)
				}
			})
		})
		//console.log(ret)
		// totals for each year to base percentages off of
		_.forEach(years, (y) => {
			let i = 0
			_.forEach(ret[y], (value) => {
				i += value
			})
			totals[y] = i
		})
		//console.log(totals)
		// now create arrays of every year combo
		_.forEach(ret, (v, k) => {
			if (!years.includes(k)) {
				return
			}
			_.forEach(v, (value, label) => {
				if (!_.has(d, `${label}`)) {
					_.set(d, `${label}`, [])
				}
				d[label].push(value)
			})
		})
		//console.log(d)
		// create table data
		let tableData = []
		_.forEach(d, (v, k) => {
			let r = {
				realtor: k,
			}
			r[years[0]] = ((v[0] / totals[years[0]]) * 100).toFixed(2)
			r[years[1]] = ((v[1] / totals[years[1]]) * 100).toFixed(2)
			// Percent
			let p = r[years[1]] / r[years[0]]
			if (r[years[0]] > r[years[1]]) {
				let t = r[years[1]] / r[years[0]]
				t = t * 100
				t = (100 - t).toFixed(2)
				t = t * -1
				if (isNaN(t)) {
					t = 0
				}
				r["changed"] = t
			} else {
				let t = r[years[1]] / r[years[0]]
				t = t - 1
				t = t * 100
				t = t.toFixed(2)
				if (isNaN(t)) {
					t = 0
				}
				r["changed"] = t
			}
			//r["changed"] = Math.round(p * 100)
			tableData.push(r)
		})
		// Reverse years and data so latest is on top.
		years = _.reverse(years)
		_.forEach(d, (v, k) => {
			v = _.reverse(v)
		})
		const data = {
			labels: years,
			datasets: [
				{
					label: "Yes",
					backgroundColor: colorArray[1],
					borderColor: colorArray[1],
					borderWidth: 1,
					hoverBackgroundColor: "rgba(50,149,236,0.5)",
					hoverBorderColor: "rgba(50,149,236,0.9)",
					data: d["Yes"],
				},
				{
					label: "No",
					backgroundColor: colorArray[8],
					borderColor: colorArray[8],
					borderWidth: 1,
					hoverBackgroundColor: "rgba(50,149,236,0.5)",
					hoverBorderColor: "rgba(50,149,236,0.9)",
					data: d["No"],
				},
			],
		}

		const columns = [
			{
				Header: "Realtor Sale?",
				accessor: "realtor",
			},
			{
				Header: years[0],
				accessor: years[0],
				Cell: (props) => props.value + "%",
			},
			{
				Header: years[1],
				accessor: years[1],
				Cell: (props) => props.value + "%",
			},
			{
				Header: "% Change",
				accessor: "changed",
				Cell: (props,pdf) => {
					if (pdf === true) {
						return props.value
					}
					if (props.value > 0) {
						return (
							<span style={{ color: "green" }}>
								<i className="fas fa-caret-up" />
								{props.value}%
							</span>
						)
					} else {
						return (
							<span style={{ color: "red" }}>
								<i className="fas fa-caret-down" />
								{props.value}%
							</span>
						)
					}
				},
			},
		]

		return (
			<div className="content">
				<div className="statBox__row statBox__row--double">
					<div className="statBox__box">
						<ImageExport name="RealtorSales" />
						<HorizontalBar data={data} options={lineOptions} />
					</div>
					<div className="statBox__box">
						<FullTable
							data={tableData}
							columns={columns}
							name="salesytd__realtor"
							title="Realtor Sales"
						/>
					</div>
				</div>
			</div>
		)
	}

	generateProperties = () => {
		return _.map(this.props.activeProperties, (v) => {
			let property = _.find(this.props.payload.public.properties, { id: v })
			return (
				<div key={v}>
					<h3>{property.name}</h3>
					<div className="imageGroup">
						<h3>Builder Sales</h3>
						{this.builderSales(v)}
					</div>
					<div className="imageGroup">{this.salesPrice(v)}</div>
					<div className="imageGroup">{this.squareFootage(v)}</div>
					<div className="imageGroup">{this.realtorSales(v)}</div>
				</div>
			)
		})
	}

	render() {
		if(this.props.activeProperties.length > 1) {
			return (
				<div className="pleaseChoose">
					<h1>Please choose one community to view reporting.</h1>
				</div>
			)
		}
		if (this.props.payloadStatus) {
			return (
				<div className="sales">
					<div className="imageGroup">
						<Title title="YTD Sales Report" showDate={false} />
						<h3 className="content">Builder Sales</h3>
						{this.builderSales()}
					</div>
					<div className="imageGroup">
						<h3 className="content">Sales Price</h3>
						{this.salesPrice()}
					</div>
					<div className="imageGroup">
						<h3 className="content">Square Footage</h3>
						{this.squareFootage()}
					</div>
					<div className="imageGroup">
						<h3 className="content">Realtor Sales</h3>
						{this.realtorSales()}
					</div>
				</div>
			)
		} else if (this.props.activeProperties.length !== 1) {
			return (
				<div className="pleaseChoose">
					<h1>Please choose one community to view reporting.</h1>
				</div>
			)
		} else {
			return ""
		}
	}
}

function mapStateToProps(state) {
	return {
		currentDates: state.currentDates,
		compareDates: state.compareDates,
		payload: state.payload,
		payloadStatus: state.payloadStatus,
		activeProperties: state.activeProperties,
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators({}, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(SalesYTD)
